import React from 'react';

import PreChatContainer from '../ui/PreChatContainer';
import PreChatHeader from '../ui/PreChatHeader';
import InfoCardGrid from '../ui/InfoCardGrid';
import InfoCard from '../ui/InfoCard';
import BulletList from '../ui/BulletList';

const ReviseRejectedClaim: React.FC = () => {
    const analyzeItems = [
        'Rejection reason identification',
        'Required field corrections',
        'Coding and modifier adjustments',
        'Documentation improvements',
        'Resubmission strategy'
    ];

    const rejectionReasons = [
        '"Denied for lack of prior authorization"',
        '"Incorrect diagnosis codes"',
        '"Missing or invalid modifiers"',
        '"Incomplete documentation"',
        '"Service not covered under policy"'
    ];

    return (
        <PreChatContainer>
            <PreChatHeader
                icon="/assets/revise-rejected-claim.png"
                iconAlt="Revise Rejected Claim"
                title="Revise Rejected Claim"
                description="I'll help you fix and resubmit claims that were rejected by payers."
                instructions="Please attach your rejected claim and the rejection notice using the paperclip icon in the chatbox below or drag & drop them here."
            />

            <InfoCardGrid>
                <InfoCard title="I will analyze the following:">
                    <BulletList items={analyzeItems} />
                </InfoCard>
                <InfoCard title="Examples of rejection reasons:">
                    <BulletList items={rejectionReasons} />
                </InfoCard>
            </InfoCardGrid>
        </PreChatContainer>
    );
};

export default ReviseRejectedClaim;



